import Utils from "@/common/Utils";

class TokenService {
  getLocalRefreshToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.refreshToken;
  }

  getLocalAccessToken() {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.accessToken;
  }

  updateLocalAccessToken(token) {
    let user = JSON.parse(localStorage.getItem("user"));
    user.accessToken = token;
    localStorage.setItem("user", JSON.stringify(user));
  }

  getUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  setUser(user) {
    Utils.log(JSON.stringify(user));
    localStorage.setItem("user", JSON.stringify(user));
    localStorage.setItem("clientIdx", user.clientIdx);
    localStorage.setItem("clientName", user.clientName);
    localStorage.setItem("companyIdx", user.companyIdx);
    localStorage.setItem("companyName", user.companyName);
  }

  removeUser() {
    localStorage.removeItem("user");
    localStorage.removeItem("clientIdx");
    localStorage.removeItem("clientName");
    localStorage.removeItem("companyIdx");
    localStorage.removeItem("companyName");
  }
}

export default new TokenService();
